import { bool, fail, isRecord, list, optionalText, text } from '../../../shared/api/onecEnvelope'

/** Wire-контракт фото (B2b, `PhotoContracts.cs`). */
export const ONEC_PHOTO_SCHEMAS = {
  present: 'onec.business.Catalog_ProductsWithPhotos.v1',
  setMain: 'onec.business.Catalog_SetMainPhoto.v1',
} as const

/** Ключи файлов фото, главный первым. */
export const decodeFileKeys = (raw: unknown): string[] => list(raw, 'data', (item, index) => text(item, `data[${index}]`))

export const decodeMainPhotoResult = (raw: unknown): boolean => bool(raw, 'data')

/** Итоги загрузки снимка, как их называет служба. */
export const UPLOAD_OUTCOMES = ['Written', 'SkippedNotPublished', 'AlreadyAttached'] as const
export type UploadOutcome = (typeof UPLOAD_OUTCOMES)[number]

const isUploadOutcome = (value: string): value is UploadOutcome => (UPLOAD_OUTCOMES as readonly string[]).includes(value)

export function decodeUploadResult(raw: unknown): { outcome: UploadOutcome; refKey: string | null } {
  if (!isRecord(raw)) fail('итог загрузки — не объект')
  const outcome = text(raw.outcome, 'outcome')
  if (!isUploadOutcome(outcome)) fail(`outcome — неизвестное значение ${outcome}`)
  return { outcome, refKey: optionalText(raw.refKey, 'refKey') }
}
